export default {
  setOrgTypes(state, data) {
    state.orgTypes = data;
  },
  setOrgData(state, data) {
    state.orgData = data;
  },
  setMyOrgList(state, data) {
    state.myOrgList = data;
  },
  setOtherOrgList(state, data) {
    state.otherOrgList = data;
  },
  setSearchMembers(state, data) {
    state.serchMembers = data;
  },
  setNoSearchMembers(state, query) {
    state.noSearchMembers = query;
  },
  setCurrentProfileOrg(state, data) {
    state.currentOrgProfile = data;
  },
  setNoSearchOrgs(state, query) {
    state.noSearchOrgs = query;
  },
  setNumFollowersChannel(state, data) {
    state.numFollowersChannel = data;
  },
  setOrgPosts(state, posts) {
    state.orgPosts = posts;
  },
  async setCollectionOrg(state, { collectionName, data, isReply }) {
    if (Array.isArray(state[collectionName])) {
      if (collectionName === 'orgPosts') {
        state[collectionName] = [...state[collectionName], ...data];
      } else {
        state[collectionName] = [...data];
      }
    }
  },
  addOrgPost(state, post) {
    if (!state.orgPosts) {
      state.orgPosts = [];
    }
    state.orgPosts.unshift(post);
  },
  setStatusLoad(state, status) {
    state.isLoading = status;
  },
  setJoinRequests(state, requests) {
    state.joinRequests = requests;
  },
  clearJoinRequests(state) {
    state.joinRequests = [];
  },
  setBannedUsers(state, data) {
    state.bannedUsersList = data;
  },
};
